// @flow
import Spinner from "components/Spinner";
import * as React from "react";
import Button from "ui/atoms/Button";
import Flex from "ui/atoms/Flex";

import Modal from "@/ui/Modal";

type Props = {
  onConfirm: () => Promise<void>,
  onCancel: () => Promise<void>,
  onClose: () => void,
  isSubmitting?: boolean,
};

function OfficeUsePrompt({
  onConfirm,
  onCancel,
  onClose,
  isSubmitting,
}: Props): React.Node {
  return (
    <Modal
      centered
      open
      footer={() => undefined}
      onCancel={onClose}
      title="Office use questions"
      width="650px"
    >
      <p className="text-base text-gray-500 mb-4">
        The selected form contains office use questions. Would you like to
        pre-fill before sending?
      </p>
      <Flex $horizontalSpacing="medium" justify="end">
        <Button $primary $quarter disabled={isSubmitting} onClick={onConfirm}>
          {isSubmitting && <Spinner className="mr-2" />}
          Pre-fill
        </Button>
        <Button $primary $quarter disabled={isSubmitting} onClick={onCancel}>
          Send
        </Button>
      </Flex>
    </Modal>
  );
}

export default OfficeUsePrompt;
